.fillingProgress {
    appearance: none;
    display: block;
    height: 0.5rem;
    width: 100%;
    border: none;
    border-radius: 0.25rem;
    overflow: hidden;
    background: var(--mantine-color-gray-2);
}

.fillingProgress::-webkit-progress-bar {
    background-color: #cedbdf;
    border-radius: 0.25rem;
}

.fillingProgress::-webkit-progress-value {
    background-color: #f28650;
    border-radius: 0.25rem;
    transition: width 0.5s linear;
}

.fillingProgressComplete::-webkit-progress-value {
    background-color: #428c37;
}

.fillingProgress::-moz-progress-bar {
    background-color: #f28650;
    border-radius: 0.25rem;
}

.fillingProgressComplete::-moz-progress-bar {
    background-color: #428c37;
}
